export interface IMenuCollection extends Components.Schemas.AssetDto {}
export interface IGetMenuCollectionParams extends Paths.MenuControllerGet.QueryParameters {
  id: string;
}
export interface IGetMenuDefaultCollectionParams extends Paths.MenuControllerGetDefault.QueryParameters {}

export interface IMenuCategory extends Components.Schemas.CategoryToAssetDto {}
export interface IMenuItem extends Components.Schemas.MenuItemToAssetDto {}

export interface IGetMenuMealBuilderPicksParams
  extends Paths.MenuControllerGetMealBuilderPicks.PathParameters, Paths.MenuControllerGetMealBuilderPicks.QueryParameters {}
export interface IGetMenuDefaultMealBuilderPicksParams extends Omit<IGetMenuMealBuilderPicksParams, 'storeId'> {}

export enum ECategoryType {
  IsAddOns = 'isAddOns',
  IsAddOnsEnable = 'isAddOnsEnable',
  IsAddOnsDisable = 'isAddOnsDisable',
}

export interface IMenuItemWithCategoryNameAndType extends IMenuItem {
  category?: string;
  type?: ECategoryType;
}

export interface IMenuAddOn extends Components.Schemas.MenuItemToAssetDto {}
export interface IAddOnsCategory extends Components.Schemas.CategoryToAssetDto {}

export enum EMenuErrorCode {
  ItemNotFound = 'error.menuItemNotFoundException',
}

export enum EMenuErrorMessage {
  ItemNotFound = 'Menu item not found',
}

export enum EProductType {
  SandwichOnly = 'sandwichOnly',
  Combo = 'combo',
  Bundle = 'bundle',
  Other = 'other',
}

export enum EMealBuilderRole {
  Drink = 'drink',
  Side = 'side',
}
